/**
 * Amplitude event names for the CRM module.
 *
 * Event names are cross-system identifiers: a typo is accepted silently by Amplitude,
 * lands in the warehouse forever, and only surfaces weeks later when a chart reads zero.
 * They live here so a rename is one atomic edit.
 *
 * Every name below is NEW and was verified absent from the existing event set. Nothing
 * here reuses an existing name — reusing one would change the volume of a metric that
 * analyst dashboards have been built on.
 */

export const CRM_EVENTS = {
  // Listing / kanban
  LEAD_CARD_OPENED: "crm_lead_card_opened",
  LEAD_STAGE_CHANGED_BY_DRAG: "crm_lead_stage_changed_by_drag",
  LEADS_EXPORTED: "crm_leads_exported",

  // Saved views
  VIEW_CREATED: "crm_view_created",
  VIEW_UPDATED: "crm_view_updated",
  VIEW_DELETED: "crm_view_deleted",

  // Lead lifecycle
  LEAD_LINKED: "crm_lead_linked",
  LEAD_DELETED: "crm_lead_deleted",

  // Lead details right panel
  LEAD_TAB_VIEWED: "crm_lead_tab_viewed",
  NOTE_DELETED: "note_deleted_from_lead",
  TASK_CREATED: "lead_task_created",
  TASK_UPDATED: "lead_task_updated",
  TASK_COMPLETED: "lead_task_completed",
  TASK_DELETED: "lead_task_deleted",
  CHANNEL_TOGGLED: "crm_lead_channel_toggled",
  TEMPLATE_USED: "crm_template_used_on_lead",
  TEMPLATE_OPENED: "crm_template_opened",
  BOOKING_OPENED: "crm_lead_booking_opened",
  FORM_SUBMISSION_SWITCHED: "crm_form_submission_switched",
  FORM_LINK_COPIED: "crm_form_link_copied",
} as const;

export const CRM_TEMPLATE_OPEN_MODE = {
  PREVIEW: "preview",
  EDIT: "edit",
} as const;
